module.exports = __webpack_public_path__ + "static/img/sc12.e98e9df.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc12.png
// module id = u6vS
// module chunks = 25